export const parseCiplNumber = (value: string): number => {
  const normalized = String(value || "")
    .replace(/\./g, "")
    .replace(",", ".");
  return Number(normalized) || 0;
};
